import { Skeleton, TableContainer } from "@mui/material";
import { Box } from "@mui/system";
import CardHeader from "../CardHeader/CardHeader";
import CustomCard from "../CustomCard/CustomCard";
import DeliveryTableFooter from "../DeliveryTableFooter/DeliveryTableFooter";
import { calcPagesQuantity } from "../../utils";
import {
  IOption,
  ROW_PER_PAGE,
  TableColumn,
} from "../../pages/Home/models/default";
import CardDataNotFound from "../CardDataNotFound/CardDataNotFound";

export interface IRowContent {
  id: number;
  [key: string]: any;
}

interface DeliveryTableProps {
  columns?: TableColumn[];
  data?: IRowContent[];
  titleTable: string;
  subTitleTable: string;
  totalTable: number;
  totalLine: number;
  currentPage: number;
  onChangePage: (newPage: number) => void;
  isLoadingData: boolean;
  options: IOption[];
  handleOptions: (option: IOption[]) => void;
}

const DeliveryTable: React.FC<DeliveryTableProps> = ({
  columns,
  data,
  titleTable,
  subTitleTable,
  totalTable,
  totalLine,
  currentPage,
  onChangePage,
  isLoadingData,
  options,
  handleOptions,
}) => {
  const handleChangePage = (newPage: number) => {
    onChangePage(newPage);
  };

  const RANGE_NUMBER_PAGE = 5;

  const gridTemplateColumns = columns?.map(() => "auto").join(" ") ?? "auto";

  const TableLoading: React.FC = () => {
    return (
      <Box>
        {Array.from(Array(RANGE_NUMBER_PAGE)).map((_, index) => (
          <Box
            key={index}
            sx={{
              display: "grid",
              gridTemplateColumns: gridTemplateColumns,
              alignItems: "center",
              borderBottom: "1px solid #DFE0EB",
              px: 2,
              py: 1,
              columnGap: 2,
            }}
          >
            {columns?.map((column) => (
              <Skeleton
                key={column.key}
                variant="rectangular"
                height={"3rem"}
                width={"100%"}
              />
            ))}
          </Box>
        ))}
      </Box>
    );
  };
  return (
    <CustomCard sx={{ minHeight: 250 }}>
      <CardHeader
        title={titleTable}
        subTitle={subTitleTable}
        tableDropDownProps={{
          isDropDownArrow: false,
          title: "Status",
          options: options,
          getOptionLabel: (option) => option,
          onChange: (index, _selectedValue, oldChecked) => {
            const newValues: IOption[] = [...options];
            newValues[index].isChecked = !oldChecked;
            handleOptions(newValues);
          },
        }}
      />
      <TableContainer
        sx={{
          width: "100%",
          overflowX: "auto",
        }}
      >
        <Box
          sx={{
            display: "inline-block",
          }}
        >
          {isLoadingData ? (
            <TableLoading />
          ) : data?.length ? (
            data.map((row, id) => (
              <Box
                key={id}
                sx={{
                  display: "inline-grid",
                  minWidth: "100%",
                  gridTemplateColumns: gridTemplateColumns,
                  alignItems: "center",
                  borderBottom: "1px solid #DFE0EB",
                  px: 2,
                  py: 1,
                  columnGap: 2,
                }}
              >
                {columns?.map((column) => (
                  <Box key={column.key}>{row[column.key]}</Box>
                ))}
              </Box>
            ))
          ) : (
            <Box alignSelf="center">
              <CardDataNotFound
                icon="search-empty"
                title=""
                subtitle="Não foram encontrados pedidos para esse cliente."
              />
            </Box>
          )}
        </Box>
      </TableContainer>
      <DeliveryTableFooter
        displayedResults={currentPage ?? 0}
        pagesTotalTable={totalTable ?? 0}
        pagesTotalLine={totalLine}
        pagesQuantity={calcPagesQuantity(ROW_PER_PAGE, totalTable ?? 0)}
        onChangePage={handleChangePage}
      />
    </CustomCard>
  );
};

export default DeliveryTable;
